import { ApiService } from '@/services/ApiService';
import {
  OrderTemplateDto,
  OrderTemplateItemDto,
  OrderTemplatesApi
} from '@eurogast/hub-client-typescript';
import { ConfigService } from '@/services/ConfigService';

export default class OrderTemplateApiService {
  private static instance: OrderTemplateApiService;

  public static singleton(): OrderTemplateApiService {
    if (!this.instance) {
      this.instance = new OrderTemplateApiService();
    }

    return this.instance;
  }

  private orderTemplatesApi: OrderTemplatesApi;

  private constructor() {
    this.orderTemplatesApi = ApiService.wrap(OrderTemplatesApi);
  }

  public async createOrderTemplate(template: OrderTemplateDto): Promise<OrderTemplateDto> {
    return this.orderTemplatesApi.createNewOrderTemplate(
      ConfigService.getTenant(),
      template,
      ConfigService.currentCustomerId
    );
  }

  public async addItemToTemplate(templateId: number, item: OrderTemplateItemDto): Promise<OrderTemplateDto> {
    return this.orderTemplatesApi.addOrderTemplateItem(
      ConfigService.getTenant(),
      templateId,
      item,
      ConfigService.currentCustomerId
    );
  }

  public async removeItemFromTemplate(templateId: number, item: OrderTemplateItemDto): Promise<Response> {
    return this.orderTemplatesApi.removeOrderTemplateItem(
      ConfigService.getTenant(),
      templateId,
      item,
      ConfigService.currentCustomerId
    );
  }
}
